<template>
	<div
		ref="clusterElement"
		class="MultipleTopVisibilityBannersWrapper"
		:class="cssClass"
		:style="{ display: shouldHideCluster ? 'none' : undefined }"
	>
		<AdBanner
			v-for="(id, index) in bannerIds"
			:key="id"
			:containerId="id"
			:bannerType="bannerType"
			:cssClass="cssClass"
			:clusterIndex="index"
		/>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import AdBanner from './AdBanner.vue';
import { useBannerVisibility } from '../composables/useBannerVisibility';
import type { BannerType } from '../types/google-tag.types';

const props = defineProps<{
	bannerIds: string[];
	bannerType: BannerType;
	cssClass: string;
}>();

const clusterElement = ref<HTMLElement | null>(null);
const { shouldHide: shouldHideCluster } = useBannerVisibility(
	clusterElement,
	(cluster) => {
		const banners = cluster.querySelectorAll<HTMLElement>(`article.${props.cssClass}`);
		return Array.from(banners).some((banner) => banner.childElementCount > 0);
	},
);
</script>
